<template>
  <div class="section-box outline">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ $t('field.month') }}</div>
                <el-date-picker
                  v-model="dateTime"
                  type="month"
                  placeholder="Pick a month"
                  @change="selectMonth"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">{{ $t('field.hotel') }}</div>
                <el-select
                  v-model="searchParams.hotelIdList"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                  placeholder=""
                >
                  <el-option
                    v-for="item in hotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="das-form-container">
      <div class="das-form-title-container">
        <div class="das-form-title">
          <span class="main-title"> Biểu đồ cột chồng </span>
        </div>
      </div>
      <div class="chart-container">
        <VChart
          class="chart"
          :option="chartOptions"
          :loading="false"
          autoresize
          @click="onClickChart"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VChart from 'vue-echarts'
import { use } from 'echarts/core'
import { BarChart } from 'echarts/charts'
import {
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent
} from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { hotelOptions } from '../stores/hotelListStore'
import { color } from '@/utils/color'
import 'echarts'
import { getHistogramChart } from '@/api/report_service/houseKeeperReport'
import { forEach } from 'jszip/lib/object'

use([
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent,
  BarChart,
  CanvasRenderer
])

const tmpDays = []
for (let i = 1; i <= 30; i++) {
  tmpDays.push(i)
}

class Series {
  constructor() {
    this.name = this.generateName()
    this.data = this.generateData()
    this.type = 'bar'
    this.stack = 'total'
    this.barWidth = '60%'
  }

  generateName() {
    const name = (Math.random() + 1).toString(36).substring(7)
    return name
  }

  generateData() {
    const data = []
    for (let i = 0; i < 30; i++) {
      Math.random() * data.push(Math.round(Math.random() * 100))
    }
    return data
  }
}

// eslint-disable-next-line no-unused-vars
const getMockSeries = () => {
  const mockSeries = []

  for (let i = 0; i < 10; i++) {
    mockSeries.push(new Series())
  }

  return mockSeries
}

export default {
  components: {
    VChart
  },
  data() {
    return {
      dateTime: this.$moment(),
      defaultSearchParams: {
        year: this.$moment(this.dateTime).year(),
        month: this.$moment(this.dateTime).month() + 1
      },
      searchParams: {
        year: this.$moment(this.dateTime).year(),
        month: this.$moment(this.dateTime).month() + 1
      },
      hotelOptions,

      chartOptions: {
        color: color,
        tooltip: {
          trigger: 'axis'
          // backgrounColor: 'rgba(50, 50, 50, 0.2)'
        },
        legend: {
          selectedMode: false,
          orient: 'horizontal',
          left: 'center',
          bottom: 0,
          type: 'scroll'
        },
        grid: {
          left: 0,
          right: 0,
          top: 50,
          bottom: 100,
          // width: '2000px',
          containLabel: true
        },
        yAxis: {
          type: 'value'
        },
        xAxis: {
          type: 'category',
          data: [],
          nameTextStyle: {
            width: 500
          },
          triggerEvent: true
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            // xAxisIndex: [0, 1],
            start: 0,
            end: 20,
            bottom: 50,
            maxSpan: 100
          },
          {
            type: 'inside',
            show: true,
            // rangeMode: 'percent',
            // startValue: "0%",
            // endValue: "40%",
            start: 0,
            end: 50
          }
        ],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: params => {
            let totalRevenue = 0
            params.forEach(item => {
              totalRevenue += item.value
            })
            return totalRevenue
              ? params[0].name +
                  '<br>' +
                  `Tổng cộng: ${this.$displayCurrency(totalRevenue)} VND` +
                  '<br>' +
                  `${params[0].seriesName}: ${this.$displayCurrency(
                    params[0].data
                  )} VND (${(
                    (parseFloat(params[0].data) / totalRevenue) *
                    100
                  ).toFixed(2)} %)` +
                  '<br>' +
                  `${params[1].seriesName}: ${this.$displayCurrency(
                    params[1].data
                  )} VND (${(
                    (parseFloat(params[1].data) / totalRevenue) *
                    100
                  ).toFixed(2)} %)` +
                  '<br>' +
                  `${params[2].seriesName}: ${this.$displayCurrency(
                    params[2].data
                  )} VND (${(
                    (parseFloat(params[2].data) / totalRevenue) *
                    100
                  ).toFixed(2)} %)` +
                  '<br>' +
                  `${params[3].seriesName}: ${this.$displayCurrency(
                    params[3].data
                  )} VND (${(
                    (parseFloat(params[3].data) / totalRevenue) *
                    100
                  ).toFixed(2)} %)`
              : params[0].name +
                  '<br>' +
                  `Tổng cộng: ${this.$displayCurrency(totalRevenue)} VND`
          }
        },
        series: [
          {
            name: 'Đền bù',
            type: 'bar',
            stack: 'total',
            // barMinWidth: '120%',
            // barMinWidth: '200px',
            barWidth: '60%',
            // barMaxWidth: '80px',
            // label: {
            //   show: true,
            //   formatter: params => params.value
            // },
            data: []
          },
          {
            name: 'Laundry',
            type: 'bar',
            stack: 'total',
            // barMinWidth: '120px',
            barWidth: '60%',
            // label: {
            //   show: true,
            //   formatter: params => params.value
            // },
            data: []
          },
          {
            name: 'Minibar',
            type: 'bar',
            stack: 'total',
            // barMinWidth: '120px',
            barWidth: '60%',
            // label: {
            //   show: true,
            //   formatter: params => (params.value !== 0 ? params.value : '')
            // },
            data: []
          },
          {
            name: 'Thẻ từ',
            type: 'bar',
            stack: 'total',
            // barMinWidth: '120px',
            barWidth: '60%',
            // label: {
            //   show: true,
            //   formatter: params => params.value
            // },
            data: []
          }
        ]
        // series: getMockSeries()
      }
    }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    onClickChart(e) {
      // console.log('CLICK CHART::', e)
      this.$emit('clickChart', e)
    },
    selectMonth(value) {
      this.searchParams.month = this.$moment(this.dateTime).month() + 1
      this.searchParams.year = this.$moment(this.dateTime).year()
    },
    async attachData() {
      let data = await getHistogramChart(this.searchParams)
      this.chartOptions.series[0].data = []
      this.chartOptions.series[1].data = []
      this.chartOptions.series[2].data = []
      this.chartOptions.series[3].data = []
      this.chartOptions.xAxis.data = []
      data.data.map(day => {
        this.chartOptions.xAxis.data.push(
          this.$moment(day.date).format('DD-MM-YYYY')
        )
        this.chartOptions.series[0].data.push(day?.date_revenue[0]?.revenue)
        this.chartOptions.series[1].data.push(day?.date_revenue[1]?.revenue)
        this.chartOptions.series[2].data.push(day?.date_revenue[2]?.revenue)
        this.chartOptions.series[3].data.push(day?.date_revenue[3]?.revenue)
      })
    }
  }
}
</script>

<style></style>

<style lang="scss" scoped>
.chart-container {
  width: 100%;
  display: flex;

  .chart {
    width: 100%;
    height: 500px;
  }
}
</style>
